import { Trans } from 'i18n';
import { Typography } from 'ui';

export const Complete = () => {
  return (
    <Typography>
      <Trans
        namespace="features"
        i18nKey="helpGuides.complete.message"
        components={{
          complete: <Typography component="span" fontWeight="bold" />,
          qualityReport: <Typography component="span" fontWeight="bold" />,
        }}
      />
    </Typography>
  );
};
